import React from 'react';
import classNames from 'classnames';
import StepMarker from '../step-marker';
import StepContent from '../step-content';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
const Step = ({
  marker,
  label = '',
  active = false,
  passed = false,
  completed = false,
  invalid = false,
  disabled = false,
  children = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onClick = null,
}) => {
  const classes = classNames('ws-ui-step-line-item', {
    'ws-ui-step-line-item--active': active,
    'ws-ui-step-line-item--passed': passed,
    'ws-ui-step-line-item--completed': completed,
    'ws-ui-step-line-item--invalid': invalid,
    'ws-ui-step-line-item--disabled': disabled,
    'ws-ui-step-line-item--without-content': !children,
  });

  return (
    <div className={classes}>
      <StepMarker
        className="ws-ui-step-line-item__marker"
        label={label}
        active={active}
        passed={passed}
        completed={completed}
        invalid={invalid}
        disabled={disabled}
        onClick={onClick}
      >
        {marker}
      </StepMarker>
      {children && <StepContent className="ws-ui-step-line-item__content">{children}</StepContent>}
    </div>
  );
};

export default Step;
